// extracted by mini-css-extract-plugin
export default {"wrapper":"kanban_wrapper__StZQ8","opacity-transition":"kanban_opacity-transition__x+Cer"};